import { Api } from "../Api";
const chatAndNotificationEndpoints = Api.injectEndpoints({
  endpoints: (builder) => ({
    getAllChats: builder.query({
      query: ({ roomId = "",club_id,type='all' }) => ({
        url: `/mocion/chats/all?chat_id=${roomId}&club_id=${club_id}&type=${type}`,
         headers: {
          platform: "web",
        },
      }),
      providesTags: ["chats"],
    }),
    sendMessage: builder.mutation({
      query: (data: any) => ({
        url: `/mocion/chats/message`,
         headers: {
          platform: "web",
        },
        method: "POST",
        body: data,
      }),
    }),
    uploadFile: builder.mutation({
      query: (data: any) => ({
        url: `/mocion/chats/upload`,
         headers: {
          platform: "web",
        },
        method: "POST",
        body: data,
      }),
    }),
    getMessagesForChat: builder.query({
      query: ({ id, page }) => ({ url: `/mocion/chats/id/${id}?page=${page}`, headers: {
          platform: "web",
        }, }),
      providesTags: ["chats"],
    }),

    getNotifications: builder.query({
      query: ({ page=1, limit=10 }) => ({
        url: `/mocion/notification/all?page=${page}&limit=${limit}`,
        headers: {
          platform: "web",
        },
      }),
      providesTags: ["notifications"],
    }),
     readNotification: builder.mutation({
      query: (data) => ({
        url: `/mocion/notification/read`,
         headers: {
          platform: "web",
        },
        method: "POST",
        body: data
      }),
      invalidatesTags: ["notifications"],
    }),
    createChat: builder.mutation({
      query: (id: number) => ({
        url: `/mocion/chats/create`,
         headers: {
          platform: "web",
        },
        method: "POST",
        body: {
          player_id: id,
        },
      }),
      invalidatesTags: ["chats"],
    }),
    deleteMassege: builder.mutation({
      query: ({id}) => ({
        url: `/mocion/chats/${id}`,
         headers: {
          platform: "web",
        },
        method: "DELETE",
        body: {
        },
      }),
      invalidatesTags: ["chats"],
    }),
  }),
});
export const {
  useGetAllChatsQuery,
  useSendMessageMutation,
  useUploadFileMutation,
  useGetMessagesForChatQuery,
  useGetNotificationsQuery,
  useCreateChatMutation,
  useReadNotificationMutation,
  useDeleteMassegeMutation
} = chatAndNotificationEndpoints;
